export const ORDER_TYPE = {
  GROCERY: "grocery",
  TAKEOUT: "takeout",
};

export function normalizeOrderType(value) {
  const normalized = String(value || "").trim().toLowerCase();

  if (normalized === ORDER_TYPE.GROCERY) return ORDER_TYPE.GROCERY;
  if (normalized === ORDER_TYPE.TAKEOUT) return ORDER_TYPE.TAKEOUT;

  return null;
}

export function getProductOrderType(product) {
  const type = String(product?.type?.value || "")
    .trim()
    .toLowerCase();

  if (type === "grocery") {
    return ORDER_TYPE.GROCERY;
  }

  if (type === "prepared food" || type === "takeout" || type === "take out") {
    return ORDER_TYPE.TAKEOUT;
  }

  return null;
}

export function isGroceryProduct(product) {
  return getProductOrderType(product) === ORDER_TYPE.GROCERY;
}

export function isTakeoutProduct(product) {
  return getProductOrderType(product) === ORDER_TYPE.TAKEOUT;
}

export function getProductDetailUrl(product, variantId) {
  const orderType = getProductOrderType(product);
  const base =
    orderType === ORDER_TYPE.TAKEOUT
      ? `/takeout/${product.handle}`
      : `/products/${product.handle}`;

  return variantId ? `${base}?variant=${encodeURIComponent(variantId)}` : base;
}

export function getCheckoutUrl(orderType) {
  return orderType === ORDER_TYPE.TAKEOUT
    ? "/checkout/takeout"
    : "/checkout/grocery";
}
